// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ikZ0a","terms":"styles_terms__1bcFg","blueLink":"styles_blueLink__3SxYS","noLink":"styles_noLink__2pjSh"};